<template>
    
    <setup_content v-if="active_step == 'profitable_step1'" title="Чистый операционный доход для объектов оценки (руб./год)">

        <template v-slot:buttons>
            <div class="d-flex justify-content-center mb-2" style="gap: .625rem;">
				<b-button v-if="check_roles([ 'model' ])" variant="outline-primary-secondary" v-on:click="() => $emit('update_counts')">
                    <span>Проверка заполненности</span><base-icon name="refresh" size="md" />
                </b-button>

                <b-button v-if="!!(objects_count - data.objects_count)"
                    variant="outline-primary-secondary"
                    @click="() => $emit('set_active_step', 'profitable_step1_1')"
                    >
                    <span>{{ not_editable ? "Настройки расчета" : "Настроить расчет" }}</span><base-icon name="settings" size="md" />
                </b-button>
            </div>
        </template>

        <statistic :total="objects_count" :stats="[['', data.objects_count]]" :warning="!!(objects_count - data.objects_count)">
            <template v-slot:warning>
                <div style="line-height: 1.5rem;">
                    У части объектов оценки характеристика не заполнена.<br>
                    <!-- Дозаполните недостающие значения и проведите проверку снова или <i>настройте расчет чистого операционного дохода для объектов оценки</i> -->
                </div>
            </template>
        </statistic>

    </setup_content>

    <!-- Настройка расчета Чистого операционного дохода -->

    <actual_gross_income v-else-if="active_step.startsWith('profitable_step1_1')"
		:id="id"
		:group_id="group_id"
        :objects_count="objects_count - data.objects_count" :data="data.actual_gross_income"
		v-on:set_value="(key, value) => set_value('actual_gross_income.' + key, value)"
        :active_step="active_step" v-on:set_active_step="(step_id) => $emit('set_active_step', step_id)"
		v-on:update_counts="() => $emit('update_counts')"
		v-on:need_refresh="() => $emit('need_refresh')"
        :not_editable="not_editable"
        :capitalization_data="capitalization_data"
    />

    <setup_content v-else-if="active_step == 'profitable_step1_2'" title="Операционные расходы для объектов оценки (руб./год)">

        <template v-slot:buttons>
            <div v-if="check_roles([ 'model' ])" class="d-flex justify-content-center mb-2" style="gap: .625rem;">
                <b-button variant="outline-primary-secondary" v-on:click="() => $emit('update_counts')">
                    <span>Проверка заполненности</span><base-icon name="refresh" size="md" />
                </b-button>
            </div>
        </template>

        <statistic :total="objects_count - data.objects_count" :stats="[['', data.operating_expenses.objects_count]]"
            :warning="!!(objects_count - data.objects_count - data.operating_expenses.objects_count)"
        >
            <template v-slot:warning>
                <div style="line-height: 1.5rem;">
                    У части объектов оценки характеристика не заполнена.<br>
                    <!-- Дозаполните недостающие значения и проведите проверку снова или <i>настройте расчет операционных расходов для объектов оценки</i> ниже -->
                </div>
            </template>
        </statistic>

        <setup_frame v-if="!!(objects_count - data.objects_count - data.operating_expenses.objects_count)"
            title="Настройка расчета операционных расходов для объектов оценки"
        >

            <element_row
                title="Доля операционных расходов в действительном валовом доходе" :data="data.operating_expenses.actual_gross_income_share"
                :validation="fields['operating_expenses.actual_gross_income_share']" v-on:set_value="(key, value) => set_value(`operating_expenses.actual_gross_income_share.${key}`, value)"
                :readonly="!check_roles([ 'model' ]) || not_editable"
            />

        </setup_frame>

    </setup_content>

</template>

<script>
import setup_content from "../../setup_assets/content"
import setup_frame from "../../setup_assets/frame"
import statistic from "../../setup_assets/statistic"
import actual_gross_income from "./actual_gross_income"
import api from "../../../../../../api"
import element_row from "../../../../../widgets/element-row"

export default
{
	props :
	{
		id : String,
		group_id : String,
        capitalization_data : Object,
		data : Object,
        objects_count : Number,
        active_step : String,
		not_editable : Boolean
	},

	components :
	{
        setup_content,
        setup_frame,
		statistic,
        actual_gross_income,
        element_row
	},

	data()
	{
		return {
            fields: {
                "operating_expenses.actual_gross_income_share":
                {
                    check: (value) => api.check_number({ value : value, gte : 0, lte : 1 }),
                    msg: "От 0 до 1"
                }
            }
		}
	},

	methods :
	{
        
		check_roles(roles)
		{
			return api.check_roles(this, roles)
		},

        set_value(field, value)
        {
            this.$emit("set_value", field, value)
        }
	}
}

</script>
